// extracted by css-extract-rspack-plugin
export default {"itemList":"itemList-oMueKm","itemListTitle":"itemListTitle-f3fzbN text-headline-md","item":"item-HdZk9y"};